import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';

import { Broker } from '@c4/core';

import { ProgrammingUtilsService } from './utils.service';

import {
  SET_CODEITEM_INITIAL_STATE, SELECT_CODEITEM_CATEGORY, SELECT_CODEITEM_DEVICE,
  CLEAR_CODEITEM, SELECT_COMMAND, CLEAR_COMMAND, SET_COMPOSED_DISPLAY, SET_CODEITEM_PARENT,
  CLEAR_CODEITEM_CATEGORY, CLEAR_CODEITEM_DEVICE, SET_CODEITEM_DEVICES, SELECT_CONDITION,
  CLEAR_CONDITON, SELECT_LOOP, CLEAR_LOOP, SET_CODEITEM_COMPLETE, SET_CODEITEM_DONE,
  SET_CODEITEM_COMMANDS, SET_CONDITIONS, SET_LOOPS
} from './../../advanced/services/advanced-programming.service';

import { DeviceCategoryService } from './device-category.service';
import { SharedProgrammingService } from './shared-programming.service';

const COMMAND_TEMPLATE: any = {
  type: 1
};

const CONDITION_TEMPLATE: any = {
  type: 2
};

const LOOP_TEMPLATE: any = {
  type: 3
};

@Injectable()
export class CodeItemService {

  protected formatField: string;
  codeitem: Observable<any>;

  constructor(
    protected store: Store<any>,
    protected broker: Broker,
    protected shared: SharedProgrammingService,
    protected utils: ProgrammingUtilsService
  ) {
    this.codeitem = this.store.select(state => state.advancedProgramming.codeitem);
  }

  init() {

  }

  setType(type: number) {
    let template = undefined;

    switch (type) {
      case 1: template = COMMAND_TEMPLATE; break;
      case 2: template = CONDITION_TEMPLATE; break;
      case 3: template = LOOP_TEMPLATE; break;
      default: console.error('ci.svc: settype: invalid type given to codeitem service', type);
    }


    this.store.dispatch({ type: SET_CODEITEM_INITIAL_STATE, payload: template });
  }

  selectCategory(category: string) {
    this.store.dispatch({ type: SELECT_CODEITEM_CATEGORY, payload: category });
    this.getCategoryDevices(category);
  }

  selectDevice(device: any) {
    this.store.dispatch({ type: SELECT_CODEITEM_DEVICE, payload: device });
  }

  clear() {
    this.store.dispatch({ type: CLEAR_CODEITEM });
  }


  selectCommand(command: any) {
    console.log('cicmdsvc: command selected', command);
    if (!command.params) {
      this.store.dispatch({ type: SELECT_COMMAND, payload: { command: command, hasParams: false } });
    } else {
      this.store.dispatch({ type: SELECT_COMMAND, payload: { command: command, hasParams: true } });
    }
  }

  clearCommand() {
    this.store.dispatch({ type: CLEAR_COMMAND });
  }

  updateDisplay(source: any, formatField: string) {
    console.log('commandservice: update display');
    this.store.dispatch({ type: SET_COMPOSED_DISPLAY, payload: this.composeDisplay(source, formatField) });
  }

  setParent(parentId: number) {
    this.store.dispatch({ type: SET_CODEITEM_PARENT, payload: { parentCodeItemId: parentId } });
  }

  clearCategory() {
    this.store.dispatch({ type: CLEAR_CODEITEM_CATEGORY });
  }

  clearDevice() {
    this.store.dispatch({ type: CLEAR_CODEITEM_DEVICE });
  }

  getCategoryDevices(category: string) {
    this.store.dispatch({ type: SET_CODEITEM_DEVICES, payload: [] });
    this.broker.call({
      path: '/api/v1/categories/' + category
    }).then(devices => {
      this.store.dispatch({ type: SET_CODEITEM_DEVICES, payload: devices });
    });
  }

  selectCondition(condition: any) {
    console.log('cndci.svc:  condition selected', condition);
    if (!condition.params) {
      this.store.dispatch({ type: SELECT_CONDITION, payload: { condition: condition, valid: true } });
    } else {
      this.store.dispatch({ type: SELECT_CONDITION, payload: { condition: condition } });
    }
  }

  clearCondition() {
    this.store.dispatch({ type: CLEAR_CONDITON });
  }

  selectLoop(loop: any) {
    console.log('lopci.svc:  condition selected', loop);
    if (!loop.params) {
      this.store.dispatch({ type: SELECT_LOOP, payload: { loop: loop, valid: true } });
    } else {
      this.store.dispatch({ type: SELECT_LOOP, payload: { loop: loop } });
    }
  }

  clearLoop() {
    this.store.dispatch({ type: CLEAR_LOOP });
  }

  setComplete() {
    this.store.dispatch({ type: SET_CODEITEM_COMPLETE });
  }


  private _getCommands(id: number): Promise<Array<any>> {
    return new Promise((resolve, reject) => {
      this.broker.call({
        path: '/api/v1/items/' + id + '/commands'
      }).then(
        (commands: Array<any>) => {
          commands.sort(this.compareCommands);
          resolve(commands);
        },
        (err: any) => {
          console.log('autevtsvc: get device commands error', err);
          reject(err);
        });
    });
  }

  private _getConditions(deviceId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.broker.call({
        path: '/api/v1/items/' + deviceId + '/conditionals'
      }).then(
        (conditions: Array<any>) => {
          conditions.sort(this.compareConditions);
          resolve(conditions);
        },
        (err: any) => {
          console.log('autevtsvc: get device conditions error', err);
          reject(err);
        });
    });
  }

  private _getLoops(deviceId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.broker.call({
        path: '/api/v1/items/' + deviceId + '/loops'
      }).then(
        (conditions: Array<any>) => {
          conditions.sort(this.compareConditions);
          resolve(conditions);
        },
        (err: any) => {
          console.log('autevtsvc: get device loops error', err);
          reject(err);
        });
    });
  }

  protected composeDisplay(source: any, formatField: string): string {
    let format = source[formatField].toString();

    if (source && source.params && formatField) {
      if (format) {
        let idx = format.indexOf('PARAM');
        while (idx >= 0) {
          let token = format.substring(idx);
          token = token.split(' ')[0];
          let parts = token.split(':');
          if (parts.length === 2) {
            let paramid = parseInt(parts[1]);
            if (!isNaN(paramid)) {

              let param = source.params[paramid];
              if (param) {
                let val = param.value;
                if (param.type === 'LIST' || param.type === 'DYNAMIC_LIST') {
                  val = param.values[param.value].name;
                }

                format = format.replace(token, val);
              }
            }
          }

          idx = format.indexOf('PARAM');
        }
      }
    }

    return format;
  }

  private hasParams(codeitem: any): boolean {
    return (
      codeitem &&
      codeitem.params &&
      typeof codeitem.params === 'object' &&
      codeitem.params.length &&
      codeitem.params.length > 0
    );
  }

  private buildCreatorState(event: any, codeitem: any): string {
    let state: any = {};

    if (event && codeitem) {
      state = {
        eventId: event.eventId,
        deviceId: event.deviceId,
        type: codeitem.type,
      };

      switch (codeitem.type) {
        case 1: state.codeitem = this.buildCommandState(codeitem); break;
        case 2: state.codeitem = this.buildConditionState(codeitem.condition); break;
        case 3: state.codeitem = this.buildLoopState(codeitem.loop); break;
      }
    }

    return JSON.stringify(state);
  }

  private buildCommandState(codeitem: any): any {
    return {
      command: codeitem.command.command,
      deviceId: (codeitem.device) ? codeitem.device.id : (codeitem.deviceId || 0),
      codeitemId: (codeitem.codeitemId || 0)
    };
  }

  private buildConditionState(condition: any): any {
    return {
      condition: condition.name,
      deviceId: condition.deviceId,
      codeitemId: condition.id
    };
  }

  private buildLoopState(loop: any): any {
    return {
      loop: loop.name,
      deviceId: loop.deviceId,
      codeitemId: loop.id
    };
  }

  private compareCommands(a: any, b: any): number {
    if (a.display < b.display) {
      return -1;
    } else if (a.display > b.display) {
      return 1;
    } else {
      return 0;
    }
  }

  private compareConditions(a: any, b: any): number {
    if (a.display < b.display) {
      return -1;
    } else if (a.display > b.display) {
      return 1;
    } else {
      return 0;
    }
  }

  private compareLoops(a: any, b: any): number {
    if (a.display < b.display) {
      return -1;
    } else if (a.display > b.display) {
      return 1;
    } else {
      return 0;
    }
  }

  protected error(error: any) {
    this.shared.error(error);
  }

  private compareDevices(a: any, b: any) {
    if (!(a) && !(b)) return 0;
    if (!(a)) return -1;
    if (!(b)) return 1;
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  }

  save() {
    let codeitem = this.utils.getValue(this.store, s => s.advancedProgramming.codeitem);
    switch (codeitem.type) {
      case 1: this.saveCommand();
      case 2: this.saveCondition();
      case 3: this.saveLoop();
      default: {
        console.error('autosvc: invalid code item type', codeitem);
        throw new Error('invalid code item type');
      }
    }
  }


  private _saveCommand(event: any, codeitem: any): Promise<any> {
    // NOTE that the body uses the deviceId from the selected command
    // because the command might be intended for a protocol driver

    /**
       * NOTE: we call saveCommand in two contexts: when creating a new code item, in which
       * case we have built up a lot of supporting metadata about the new item, such as device,
       * category, etc., and also when pasting an existing code item in which case we have no
       * such supporting data.  So we get the deviceid differently in each case.
       */

    let data: any = {
      'codeitemId': codeitem.codeitemId || 0,
      'deviceId': (codeitem.command.deviceId) ? codeitem.command.deviceId : codeitem.deviceId,
      'command': codeitem.command.command,
      'beforeCodeItemId': codeitem.beforeCodeItemId || 0,
      'parentCodeItemId': codeitem.parentCodeItemId || 0,
      'creator': ''
    };

    if (this.hasParams(codeitem.command)) {
      data.params = [];
      codeitem.command.params.forEach((param: any) => {
        if (param.value) {
          data.params.push({
            name: param.name,
            value: param.value
          });
        }
      });
    }

    data.creatorstate = JSON.stringify(this.buildCreatorState(event, codeitem));

    console.log('cmdsvc: saving code item:', data);
    return this.broker.call({
      method: 'POST',
      path: '/api/v1/items/' + event.deviceId +
      '/events/' + event.eventId + '/commands',
      data: data
    });
  }

  private _saveCondition(event: any, codeitem: any): Promise<any> {

    // NOTE see saveCommand()
    let data: any = {
      'codeitemId': codeitem.codeitemId,
      'deviceId': (codeitem.condition.deviceId) ? codeitem.condition.deviceId : codeitem.deviceId,
      'conditional': codeitem.condition.name,
      'beforeCodeItemId': codeitem.beforeCodeItemId || 0,
      'parentCodeItemId': codeitem.parentCodeItemId || 0,
      'creator': ''
    }

    if (this.hasParams(codeitem.condition)) {
      data.params = [];
      codeitem.condition.params.forEach((param: any) => {
        if (param.value) {
          data.params.push({
            name: param.name,
            value: param.value
          });
        }
      });
    }

    data.creatorstate = JSON.stringify(this.buildCreatorState(event, codeitem));

    console.log('cndsvc: saving code item:', data);
    return this.broker.call({
      method: 'POST',
      path: '/api/v1/items/' + event.deviceId +
      '/events/' + event.eventId + '/conditionals',
      data: data
    });
  }

  _saveLoop(event: any, codeitem: any): Promise<any> {

    // NOTE see saveCommand()
    let data: any = {
      'codeitemId': codeitem.codeitemId,
      'deviceId': (codeitem.loop.deviceId) ? codeitem.loop.deviceId : codeitem.deviceId,
      'loop': codeitem.loop.name,
      'beforeCodeItemId': codeitem.beforeCodeItemId || 0,
      'parentCodeItemId': codeitem.parentCodeItemId || 0,
      'creator': ''
    };

    if (this.hasParams(codeitem.loop)) {
      data.params = [];

      codeitem.loop.params.forEach((param: any) => {
        if (param.value) {
          data.params.push({
            name: param.name,
            value: param.value
          });
        }
      });
    }

    data.creatorstate = JSON.stringify(this.buildCreatorState(event, codeitem));

    console.log('cmdsvc: saving code item:', data);
    return this.broker.call({
      method: 'POST',
      path: '/api/v1/items/' + event.deviceId + '/events/'
      + event.eventId + '/conditionals',
      data: data
    });
  }

  private done() {
    this.store.dispatch({ type: SET_CODEITEM_DONE });
  }

  private resolveDevices(items: Array<any>): Array<any> {
    let devices = [];
    let devMap = {};

    items.forEach((item: any) => {
      switch (item.type) {
        case 7:
          let parent = devMap[item.parentId];
          if (parent && parent.typeName === 'device') {
            parent.proxies = parent.proxies || [];
            parent.proxies[item.id] = item;
            if (parent.proxy === item.proxy) {
              parent.defaultProxy = item;
              parent.protocolName = parent.name;
              parent.name = item.name;
            }
          } else {
            devMap[item.id] = item;
            devices.push(item);
          }
          break;
        case 6:
        default:
          devMap[item.id] = item;
          devices.push(item);
          break;
      }
    });

    return devices;
  }

  private working(state: boolean) {
    this.shared.ready(!state);
  }

  private saveCommand(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.working(true);
      try {

        Observable.combineLatest(
          this.store.select(state => state.advancedProgramming.event),
          this.store.select(state => state.advancedProgramming.codeitem.command),
          (event, command) => {
            return { event, command };
          }).take(1).subscribe(
          (data: any) => {
            this._saveCommand(data.event.event, data.command).then(
              res => {
                console.log('coditm.svc: command saved');
                this.done();
                resolve();
              },
              err => {
                console.error('coditm.svc: error saving command', err);
                this.error(true);
                reject(err);
              });
          });

      } catch (e) {
        console.error('coditm.svc: exception saving command', e);
        this.error(true);
        reject(e);
      } finally {
        this.working(false);
      }
    });
  }

  private getCommands(device: any) {
    this.working(true);

    try {
      let id = ((device.defaultProxy) ? device.defaultProxy.id : device.id);
      this._getCommands(id).then(
        (commands: Array<any>) => {
          console.log('cicmd.svc: got commands');
          this.store.dispatch({ type: SET_CODEITEM_COMMANDS, payload: commands });
        },
        err => {
          console.error('cicmd.svc: error getting commands', err);
          this.store.dispatch({ type: SET_CODEITEM_COMMANDS, payload: [] });
        });
    } catch (e) {
      console.error('cicmd.svc: exception getting commands', e);
      this.store.dispatch({ type: SET_CODEITEM_COMMANDS, payload: [] });
    } finally {
      this.working(false);
    }
  }

  private saveCondition() {
    try {
      this.working(true);

      Observable.combineLatest(
        this.store.select(state => state.advancedProgramming.event.event),
        this.store.select(state => state.advancedProgramming.codeitem.condition),
        (event, condition) => { return { event, condition } }
      ).take(1).subscribe(
        (data: any) => {
          this._saveCondition(
            data.event.event, data.condition).then(
            res => {
              console.log('cndci.svc: condition code item saved');
              this.done();
            },
            err => {
              console.error('cndci.svc: error saving condition code item', err)
              this.error(err);
            });
        });

    } catch (e) {
      console.error('cndci.svc: exception saving condition code item', e);
      this.error(e);
    } finally {
      this.working(false);
    }
  }


  private getConditions(device: any) {
    let id = ((device.defaultProxy) ? device.defaultProxy.id : device.id);

    this._getConditions(id).then(
      (conditions: Array<any>) => {
        this.store.dispatch({ type: SET_CONDITIONS, payload: conditions });
      },
      err => {
        console.error('cndci.svc:   error getting conditions', err);
      });
  }

  private saveLoop() {

    try {
      this.working(true);

      Observable.combineLatest(
        this.store.select(state => state.advancedProgramming.event.event),
        this.store.select(state => state.advancedProgramming.codeitem.loop),
        (event, loop) => { return { event, loop } }
      ).take(1).subscribe(
        (data: any) => {
          this._saveLoop(data.event.event, data.loop).then(
            res => {
              console.log('lopci.svc: code item saved');
            },
            err => {
              console.error('lopci.svc: error saving loop item', err)
              this.error(true);
            });
        });

    } catch (e) {
      console.error('lopci.svc: exception saving loop item', e);
      this.error(true);
    } finally {
      this.working(false);
    }
  }

  private getLoops(device: any) {
    let id = ((device.defaultProxy) ? device.defaultProxy.id : device.id);
    this._getLoops(id).then(
      (loops: Array<any>) => {
        this.store.dispatch({ type: SET_LOOPS, payload: loops });
      },
      err => {
        console.error('ciloop.svc: error getting loops', err);
        this.store.dispatch({ type: SET_LOOPS, payload: [] });
      });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/services/codeitem.service.ts